<template>
    <div class="content">
        <h2 class="content_title">정답확인</h2>
        <div class="answer_wrap">
            <div class="answer_txt">
                <h3>퀴즈 결과 확인</h3>
                <p>
                    총 <span class="bold">{{result.length}}</span>문제 중 <span class="bold redtxt">{{correnctAnswerCount}}</span>문제를 맞혔습니다.
                </p>
            </div>
            <table class="answer_result">
                <tr>
                    <th v-for="(item,index) in result">{{index + 1}}</th>
                </tr>
                <tr>
                    <td v-for="(item,index) in result">
                        <p v-if="item == 'correct'" class="answerright">O</p>
                        <p v-else class="answerwrong">X</p>
                    </td>
                </tr>
            </table>
            <div class="answer_reset">
                <a @click="goQuizNext(0)" href="#" class="resetbt sub">
                    다시풀기
                </a>
                <a @click="$emit('goSupplementary')" href="#" class="resetbt main">
                    다음
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props : ['result'],
    data(){
        return{
            list : []
        }
    },
    computed:{
        correnctAnswerCount(){
            let count = 0;
            _.map(this.result,(value)=>{
                if(value == 'correct') count++;
            });
            return count;
        }
    },
    methods:{
        // reset(){
        //     location.reload();
        // },
        goQuizNext(value){
            this.$emit('goQuizNext',value);
        },
    },
    mounted(){
    }
}
</script>